import type { Media } from '@wineryxplorer/shared';
import { getResponsiveImageSrcSet } from '@wineryxplorer/shared';
import { ImgWithSkeleton } from '../ui/ImgWithSkeleton';

interface ImageLoadState {
  loaded: boolean;
  loading: boolean;
  error: boolean;
  url?: string;
  blurUrl?: string;
  errorMessage?: string;
  retryCount?: number;
}

interface CarouselImageProps {
  image: Media;
  index: number;
  venueName: string;
  isCurrentImage: boolean;
  isVisible: boolean;
  imageState?: ImageLoadState;
  cloudName: string;
  prefersReducedMotion: boolean;
  transitionDuration: number;
}

export const CarouselImage = ({
  image,
  index,
  venueName,
  isCurrentImage,
  isVisible,
  imageState,
  cloudName,
  prefersReducedMotion,
  transitionDuration,
}: CarouselImageProps) => {
  // Don't render failed images
  if (imageState?.error) return null;
  
  return (
    <div
      key={image.id}
      id={`carousel-image-${index}`}
      className={`absolute inset-0 transition-opacity ease-in-out ${
        isVisible ? 'opacity-100' : 'opacity-0'
      }`}
      style={{
        transitionDuration: prefersReducedMotion ? '0ms' : `${transitionDuration}ms`,
      }}
    >
      {/* Blur placeholder */}
      {isCurrentImage && imageState?.blurUrl && !imageState.loaded && (
        <img
          src={imageState.blurUrl}
          alt=""
          className="absolute inset-0 w-full h-full object-cover filter blur-sm scale-110"
        />
      )}
      
      {/* Main optimized image */}
      {imageState?.url && (
        <ImgWithSkeleton
          src={imageState.url}
          alt={`${venueName} hero image ${index + 1}`}
          className={`w-full h-full object-cover transition-opacity duration-300 ${
            imageState.loaded ? 'opacity-100' : 'opacity-0'
          }`}
          srcSet={cloudName ? getResponsiveImageSrcSet(image.cloudinaryPublicId, cloudName) : undefined}
          sizes="(max-width: 768px) 100vw, (max-width: 1200px) 100vw, 100vw"
        />
      )}
    </div>
  );
};